export const color = {
    primary: "#9ae0f3",
    secondary: "#282c34"
}

export const theme = {
    dark:{
        color: "#9ae0f3",
        backgroundColor: "#282c34"
    },
    light: {
        color: "#282c34",
        backgroundColor: "#9ae0f3"
    }
}